import React, { useState, useEffect } from "react";
import axios from "axios";
import InputField from "../../../Pages/InputField/InputField";
import { Container, Row } from "react-bootstrap";
import baseURL from "../../../../Url/NodeBaseURL";

const WastageMaster = () => {
  const [formData, setFormData] = useState({ mrp: "", msp: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchWastage = async () => {
      try {
        const response = await axios.get(`${baseURL}/get-wastage`);
        if (response.data) {
          setFormData({
            mrp: response.data.MRP || "",
            msp: response.data.MSP || "",
          });
        }
      } catch (error) {
        console.error("Error fetching wastage details:", error);
      }
    };

    fetchWastage();
  }, []);

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${baseURL}/save-wastage`, formData);
      if (response.data.message) {
        alert(response.data.message); // Shows Saved or Updated
      } else {
        alert("Saved successfully!");
      }
    } catch (error) {
      console.error("Error saving wastage:", error);
      alert("Failed to save wastage details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-container">
      <Container className="estimate-form-container">
        <Row className="estimate-form-section">
          <h3 style={{ textAlign: "center", marginBottom: "20px" }}>Wastage Master</h3>

          <form onSubmit={handleSubmit}>
            <InputField
              label="MRP"
              type="number"
              name="mrp"
              value={formData.mrp}
              onChange={(e) => handleChange("mrp", e.target.value)}
              placeholder="Enter MRP"
              required
            />

            <InputField
              label="MSP"
              type="number"
              name="msp"
              value={formData.msp}
              onChange={(e) => handleChange("msp", e.target.value)}
              placeholder="Enter MSP"
              required
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button
                type="submit"
                disabled={loading}
                className="cus-submit-btn"
              >
                {loading ? "Saving..." : "Save"}
              </button>
            </div>
          </form>
        </Row>
      </Container>
    </div>
  );
};

export default WastageMaster;
